import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../../helpers/common'
import { register } from '../../../../helpers/reducerRegistry'
import { valByKeyWithDot } from '../../../../helpers/value'
import { ALL_STATUS } from '../constants'
import { getFiinGateReportTypes, getUserPricingPackagesPaged } from './thunk'

export const slice = createSlice({
  name: 'userManagement/subscriptionPayment/availablePackage',
  initialState: {
    isLoadingTable: true,
    data: [],
    dataById: {},
    ids: [],
    filter: {
      packageType: ALL_STATUS,
      purchaseDate: {
        from: '',
        to: '',
      },
      expiryDate: {
        from: '',
        to: '',
      },
      page: 1,
      pageSize: 10,
      totalRecords: 0,
    },
    packageTypeList: [],
  },
  reducers: {
    changeFilter: (state, { payload = {} }) => {
      state.filter = { ...state.filter, ...payload }
      if (!Object.keys(payload)?.includes('page')) {
        state.filter.page = 1
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserPricingPackagesPaged.pending, (state) => {
      state.isLoadingTable = true
    })
    builder.addCase(getUserPricingPackagesPaged.fulfilled, (state, action) => {
      state.isLoadingTable = false

      const payloadData = action.payload.data.length
        ? action.payload.data.map((item) => ({
            ...item,
            name: item.fiinGateReportTypeName,
          }))
        : []
      state.data = payloadData
      state.ids = payloadData.map((item) => item.id)
      state.dataById = keyBy(payloadData, 'id')

      state.filter.totalRecords = action.payload.totalRecords
      state.filter.page = action.payload.page
      state.filter.pageSize = action.payload.pageSize
    })
    builder.addCase(getUserPricingPackagesPaged.rejected, (state, action) => {
      state.isLoadingTable = action.payload.loading
    })

    builder.addCase(getFiinGateReportTypes.fulfilled, (state, action) => {
      state.packageTypeList = action.payload
    })
  },
})

export const selectLoadingAvailablePackage = (state) =>
  state[slice.name].isLoadingTable
export const selectAvailablePackageDataById = (id, attr) => (state) =>
  valByKeyWithDot(state[slice.name].dataById[id], attr)
export const selectAvailablePackageIds = (state) => state[slice.name].ids

export const selectFilterByKey = (key) => (state) =>
  state[slice.name].filter[key]
export const selectFilter = (state) => state[slice.name].filter

export const selectPackageTypeList = (state) =>
  state[slice.name].packageTypeList

export const { changeFilter } = slice.actions

register(slice.name, slice.reducer)
